import {
    getFormattedValue,
    processScaleType,
    unprocessScaleType,
} from "../../lib/utils.js";

/**
 * @class Pen
 * @classdesc Перо
 * */
export class Pen {
    constructor(owner, pen, renderItem) {
        this._owner = owner;
        if (typeof renderItem === "function") {
            this.serie = {
                name: pen.source || pen.name,
                type: "custom",
                renderItem: renderItem,
                itemStyle: {
                    normal: {
                        show: true,
                        color: pen.color,
                    },
                    emphasis: {
                        show: true,
                        symbolSize: 1,
                    },
                },
                lineStyle: {
                    normal: {},
                    emphasis: {},
                },
                data: [],
            };
            this.yformat = pen.yformat;
            this.penlimits = pen.penlimits;
            this.msydatazoomvalue = pen.msydatazoomvalue;
            this.yAxis = {
                type: "value",
                position: "left",
                nameLocation: "center",
                splitLine: {
                    lineStyle: {},
                },
                axisTick: {
                    show: true,
                    lineStyle: {},
                },
                nameTextStyle: {
                    padding: [0, 0, 15, 0]
                },
                splitNumber: +pen.tickcounty,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: pen.color,
                    },
                },
                axisLabel: {
                    padding: 0, //+this.attributes.tickmarginright
                    formatter: (value, index) => {
                        //формат подписей y применяем только для лог шкалы
                        if (!this._logscale) return value;
                        const result = getFormattedValue(this.yformat, unprocessScaleType(value, this._logscale), null, null, true);
                        return Number.isInteger(result) ? result : result.toFixed(1)
                    },
                },
            };
            this._logscale = pen.logscale;
            this.setInitialMinMaxy(pen.miny, pen.maxy)
            this.autoscale = pen.autoscale;
            this.unit = pen.unit;
            this._isvisible = pen.isvisible;
            this.thickness = pen.thickness;
            this.linestyle = pen.linestyle;
            this._showaxis = pen.showaxis;
            this.color = pen.color;
            this._drawconstant = pen.drawconstant;
            this.groupname = pen.groupname;
            this.mainpengroup = pen.mainpengroup;
        } else if (!pen.basic) {
            this.serie = {
                name: pen.source || pen.name,
                type: "line",
                showSymbol: true,
                yAxisIndex: pen.index,
                itemStyle: {
                    normal: {
                        show: true,
                        color: pen.color,
                    },
                    emphasis: {
                        show: true,
                        symbolSize: 1,
                    },
                },
                lineStyle: {
                    normal: {},
                    emphasis: {},
                },
                symbol: window._enums.PointType[pen.pointtype],
                symbolSize: pen.pointsize,
                step: +pen.linejoin ? "end" : false,
                data: [],
            };
            this.yformat = pen.yformat;
            this.penlimits = pen.penlimits;
            this.yAxis = {
                type: "value",
                position: "left",
                nameLocation: "center",
                splitLine: {
                    lineStyle: {},
                },
                axisTick: {
                    show: true,
                    lineStyle: {},
                },
                nameTextStyle: {
                    padding: [0, 0, 15, 0]
                },
                splitNumber: +pen.tickcounty,
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: pen.color,
                    },
                },
                axisLabel: {
                    padding: 0, //+this.attributes.tickmarginright
                    formatter: (value, index) => {
                        let result = getFormattedValue(this.getYaxisFormat(), unprocessScaleType(value, this._logscale), null, null, true);
                        const widthResult = this._owner.calcLabelOffset(result)
                        if(this.widthyaxistext && widthResult >= this.widthyaxistext){
                            result = (+result).toExponential();
                        }
                        return Number.isInteger(result) ? result : typeof result === 'string' ? result : result.toFixed(1)
                    },
                },
            };
            this._logscale = pen.logscale;
            this.setInitialMinMaxy(pen.miny, pen.maxy)
            this.autoscale = pen.autoscale;
            this.unit = pen.unit;
            this._isvisible = pen.isvisible;
            this.thickness = pen.thickness;
            this.linestyle = pen.linestyle;
            this._showaxis = pen.showaxis;
            this.color = pen.color;
            this._drawconstant = pen.drawconstant;
            this.groupname = pen.groupname;
            this.mainpengroup = pen.mainpengroup;
        } else {
            this.serie = {
                name: pen.source || pen.name,
                type: "line",
                yAxisIndex: pen.index,
                data: [],
                symbol: "none",
                symbolSize: 0,
                showSymbol: true,
                itemStyle: {
                    normal: {
                        show: true,
                        color: pen.color,
                    },
                    emphasis: {},
                },
                lineStyle: {
                    normal: {
                        show: true,
                        color: pen.color,
                        type: "solid",
                    },
                    emphasis: {},
                },
            };
            if (pen.linejoin) this.serie.step = +pen.linejoin ? "end" : false;
            this.yformat = "f3";
            this.unit = "";
            this.yAxis = {
                type: "value",
                position: "left",
                nameLocation: "center",
                show: true,
                nameTextStyle: {
                    padding: [0, 0, 15, 0]
                },
                axisTick: {
                    show: true,
                    lineStyle: {},
                },
                splitLine: {
                    lineStyle: {
                        color: this._owner.gridfill
                    },
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: pen.color,
                    },
                },
                axisLabel: {
                    padding: 0, //+this.attributes.tickmarginright
                    formatter: (value, index) => {
                        let result = getFormattedValue(this.getYaxisFormat(), unprocessScaleType(value, this._logscale), null, null, true);
                        const widthResult = this._owner.calcLabelOffset(result)
                        if(this.widthyaxistext && widthResult >= this.widthyaxistext){
                            result = (+result).toExponential();
                        }
                        return Number.isInteger(result) ? result : typeof result === 'string' ? result : result.toFixed(1)
                    },
                },
            };
            if(pen.tickcounty) this.yAxis.splitNumber = +pen.tickcounty
            if(pen.linestyle) this.linestyle = +pen.linestyle
            this._logscale = pen.logscale;
            this.setInitialMinMaxy(0, 100)
            this.autoscale = pen.autoscale;
            this._showaxis = true;
            this._isvisible = true;
            this.thickness = 1;
            this._drawconstant = pen.drawconstant;
            this.groupname = pen.groupname;
            this.mainpengroup = pen.mainpengroup;
            if(this._owner.tickcolory) this.yAxis.axisTick.lineStyle.color = this._owner.tickcolory
        }
        this.name = pen.name;
        this.idx = pen.index;
        this.yaxislabel = pen.yaxislabel
        if(this._owner.isTrendCSV){
            this.serie.smooth = true
            this.serie.showSymbol = false
            // this.serie.sampling = 'lttb'
            this.serie.large = true
            this.serie.largeThreshold = 10000
        }
    }

    /**
     * source
     * @type {string}
     */
    get source() {
        return this._source;
    }
    set source(value) {
        this._source = value;
    }

    /**
     * Имя группы
     * @type {string}
     */

    get groupname(){
        return this._groupname
    }

    set groupname(value){
        this._groupname = value
    }

    /**
     * Главное перо группы
     * @type {string}
     */

    get mainpengroup(){
        return this._mainpengroup
    }

    set mainpengroup(value){
        this._mainpengroup = value
    }

    /**
     * Подпись Y
     * @type {string}
     */

    get yaxislabel(){
        return this._yaxislabel
    }

    set yaxislabel(value){
        this._yaxislabel = value
        this.yAxis.name = value;
        this.updateYAxisesOffset?.();
    }

    /**
     * Цвет пера
     * @type {string}
     */
    get color() {
        return this.serie.lineStyle.normal.color;
    }
    set color(value) {
        if (!value) return
        this.serie.lineStyle.normal.color = value;
        this.serie.lineStyle.emphasis.color = value;
        this.serie.itemStyle.normal.color = value;
        this.yAxis.axisLine.lineStyle.color = value;
        if (this.selected) {
            this.shadow();
        }
        if (this.minilegend) this.minilegend.setColor(this.idx, value);
        this.updateYAxisesOffset?.();
    }

    setInitialMinMaxy(miny, maxy){
        this._originalminy = miny;
        this._miny = processScaleType(miny, this._logscale);
        this._originalmaxy = maxy;
        this._maxy = processScaleType(maxy, this._logscale);
    }

    updateminmaxy(silent) {
        this.broadcast?.();
        if (!this.autoscale) {
            this.yAxis.min = this._miny;
            this.yAxis.max = this._maxy;
            if (this.penlimits) {
                this.penlimits.min = this._miny;
                this.penlimits.max = this._maxy;
            }
            if (!this.selected) return
            this._mindecimal = this.getDecimals(this._miny);
            this._maxdecimal = this.getDecimals(this._maxy);
            this.msydatazoom.precision = Math.max(this._mindecimal, this._maxdecimal);
            this.msydatazoom.incrementstep = 1 / Math.pow(10, this.msydatazoom.precision);
            this.msydatazoom.format = `f${this.msydatazoom.precision}`;
        } else {
            this.yAxis.min = null;
            this.yAxis.max = null;
        }
        if (!silent) {
            this._owner.updateSeriesAxises();
            this._owner.updatePenYAxis();
        }
    }

    updateScale(){
        if (this.autoscale) {
            this.yAxis.min = null;
            this.yAxis.max = null;
            if(this._owner.autoscaleview){
                this.yAxis.scale = false;
                this.yAxis.scaleview = true;
                this._owner.updateScale();
            } else {
                this.yAxis.scale = true;
                this.yAxis.scaleview = false

                this._owner.echarts &&
                    this._owner.echarts.dispatchAction({
                        type: "dataZoom",
                        dataZoomIndex: 1,
                        startValue: -Infinity,
                        endValue: Infinity,
                    });
            }
        } else {
            this.yAxis.min = this._miny;
            this.yAxis.max = this._maxy;
            this.yAxis.scale = false;
            this.yAxis.scaleview = false;
        }
        if (this._owner.currentPen === this.idx && this._owner.updatePenYAxis) this._owner.updatePenYAxis()

        if (this.broadcast) {
            // нужно быть уверенным, что тренд уже инициализирован, и только после этого вызывать update значений по оси У
            this.updateYAxisesOffset();
        }
    }

    getYaxisFormat(){
        return this.yformat || "f3"
    }

    /**
     * Минимум
     * @type {string}
     */
    get miny() {
        return this.yAxis.min;
    }
    set miny(value) {
        this._originalminy = value;
        this._miny = processScaleType(value, this._logscale);
        this.updateminmaxy();
    }
    /**
     * Максимум
     * @type {string}
     */
    get maxy() {
        return this.yAxis.max;
    }
    set maxy(value) {
        this._originalmaxy = value;
        this._maxy = processScaleType(value, this._logscale);
        this.updateminmaxy();
    }


    /**
    * Ширина текста Оси Y
    * @type {number}
    */
    get widthyaxistext() {
        return this._widthyaxistext;
    }
    set widthyaxistext(value) {
        this._widthyaxistext = value;
    }

    /**
     * Посчитать число знаков после запятой
     * @param {number} value значение для анализа
     * @return {number} число знаков после запятой
     */
    getDecimals(value) {
        const stringval = value ? value.toString() : "";
        const pos = stringval.indexOf(".");
        if (pos === -1) return 0;
        else return stringval.length - 1 - pos;
    }
    /**
     * Видимость пера
     * @type {bool}
     */
    get isvisible() {
        return this._isvisible;
    }
    set isvisible(value) {
        this._isvisible = value;
        if (this.pens) {
            this.pens.offsets = [];
            let offset = 0;
            for (let i = 0; i < this.pens.length; i++) {
                const element = this.pens[i];
                if (!element.isvisible) {
                    offset++;
                }
                this.pens.offsets[i] = i - offset;
            }
        }
        this._owner.echarts.dispatchAction({
            type: value ? "legendSelect" : "legendUnSelect",
            name: this.serie.name
        });
        this.broadcast();
        this.updateYAxisesOffset();
        this._owner?.updateScale?.();
    }
    /**
     * Дорисовка константы
     * @type {bool}
     */
    get drawconstant() {
        return this._drawconstant;
    }
    set drawconstant(value) {
        this._drawconstant = value;
        if (!this._drawconstant) {
            //дорисовка отключилась - надо убрать за собой
            this.serie.data = this.serie.data.filter((o) => {
                return !o[3];
            });
        }
    }

    /**
     * Логарифмическая шкала пера
     * @type {bool}
     */
    get logscale() {
        return this._logscale;
    }
    set logscale(value) {
        this._logscale = value;
        //шкала изменилась, надо пересчитать min и max пера
        if (this._originalminy != undefined) {
            this._miny = processScaleType(this._originalminy, value);
        }
        if (this._originalmaxy != undefined) {
            this._maxy = processScaleType(this._originalmaxy, value);
        }
        this.updateminmaxy(true);
    }

    /**
     * Является ли перо текущим
     * @type {bool}
     */
    get selected() {
        return this._selected;
    }
    set selected(value) {
        this._selected = value;
        if (value) {
            this.shadow();
            if (this._owner.msydatazoom && !this.autoscale) {
                this._owner.msydatazoom.minvalue = this.miny ?? 0;
                this._owner.msydatazoom.maxvalue = this.maxy ?? 100;
            }
        } else {
            this.unShadow();
        }
        this.broadcast();
        this.updateYAxisesOffset();
    }
    /**
     * Тип графика
     * Линия или ступенька
     * @type {enum}
     */
    get linejoin() {
        return !!this.serie.step;
    }
    set linejoin(value) {
        this.serie.step = value ? "end" : false;
    }
    /**
     * Стиль линии
     * @type {BorderStyleType}
     */
    get linestyle() {
        return this.serie.lineStyle.normal.type;
    }
    set linestyle(value) {
        let newstyle = window._enums.PenStyleType[value];
        if (newstyle !== "none") {
            this.serie.lineStyle.normal.type =
                window._enums.PenStyleType[value];
            this.serie.lineStyle.normal.opacity = 1.0;
        } else this.serie.lineStyle.normal.opacity = 0.0;
    }

    /**
     * Автомасштабирование
     * @type {bool}
     */
    get autoscale() {
        return this._autoscale;
    }
    set autoscale(value) {
        this._autoscale = value;
        this.updateScale();
    }
    /**
     * Единицы измерения
     * @type {string}
     */
    get unit() {
        return this._unit;
    }
    set unit(value) {
        this._unit = value;
    }
    /**
     * Толщина линии
     * @type {number}
     */
    get thickness() {
        return this._thickness;
    }
    set thickness(value) {
        this._thickness = value;
        this.serie.lineStyle.normal.width = value;
        this.serie.lineStyle.emphasis.width = value;
    }
    /**
     * Тип точек
     * @type {PointType}
     */
    get pointtype() {
        return this.serie.symbol;
    }
    set pointtype(value) {
        this.serie.symbol =
            typeof value === "string" ? value : window._enums.PointType[value];
    }
    /**
     * Размер точек
     * @type {number}
     */
    get pointsize() {
        return this._pointsize || this.serie.symbolSize;
    }
    set pointsize(value) {
        this._pointsize = value;
        this.serie.symbolSize = value;
    }
    /**
     * Формат значений Y
     * @type {string}
     */
    get yformat() {
        return this._yformat;
    }
    set yformat(value) {
        this._yformat = value;
    }
    /**
     * Отображать ось значений
     * @type {boolean}
     */
    get showaxis() {
        return this._showaxis;
    }
    set showaxis(value) {
        this._showaxis = value;
        this.updateYAxisesOffset();
        this._owner.updateSeriesAxises();
    }
    /**
     * Количество делений Y
     * @type {number}
     */
    get tickcounty() {
        return this.yAxis.splitNumber;
    }
    set tickcounty(value) {
        this.yAxis.splitNumber = value;
    }
    /**
     * Выделить текущее перо
     * */
    shadow() {
        this.serie.lineStyle.normal.width = this.thickness + 2;
        if (this.pointsize)
            //ненулевой размер точки
            this.serie.symbolSize = this.pointsize + 2;
    }
    /**
     * Сбросить выделение текущего пера
     * */
    unShadow() {
        this.serie.lineStyle.normal.width = this.thickness;
        this.serie.symbolSize = this.pointsize;
    }

    destroy() {
        if (this.sampler) {
            this.sampler.destroy();
            delete this.sampler;
        }
        delete this.broadcast;
        delete this._echarts;
    }
}
